import {updateSlideInList, setNewCurrentNode} from '../../utilities';
import {
  PROTOCOL_SLIDE_TYPES,
  fetchProtocolScene,
  fetchComponentIds,
} from '@learningblocks/protocol-constants/lib/Utilities';
const NODE_COMPONENTS = 'nodeComponents';

export function slideTwoSetAsNextStep(state, payload) {
  // For handling incorrects count as the step that determines its update is higher below the hirarcy
  let incorrects = 0;

  function incrementIncorrects() {
    incorrects += 1;
  }

  function getIncorrects() {
    return incorrects;
  }

  function updateDesignSection(protocolSection) {
    return {
      ...protocolSection,
      allSlides: updateAllSlides(protocolSection.allSlides),
    };
  }

  function updateAllSlides(allSlides) {
    const slideTwo = fetchProtocolScene(allSlides, PROTOCOL_SLIDE_TYPES.TWO);
    const designSlideTwo = updateDesignSlideTwo(slideTwo);
    const updatedAllSlides = updateSlideInList(allSlides, designSlideTwo);
    return updatedAllSlides;
  }

  function updateDesignSlideTwo(slideTwo) {
    let {slideTree} = slideTwo.slideTree.reduce(
      (treeUpdate, group) => {
        // if no component is dropped in spot
        const noDrop = (nodeComponent) => nodeComponent.droppedId === null;
        // if a component was wrongly dropped in spot
        const wrongDropped = (nodeComponent) =>
          nodeComponent.droppedId !== nodeComponent.id;
        // setAsNextStep should always update the first undropped or wrongly dropped spot.
        const shouldUpdate = (nodeComponent) =>
          noDrop(nodeComponent) || wrongDropped(nodeComponent);

        function updateNodeComponent(nodeComponent) {
          if (treeUpdate.updated) {
            return nodeComponent;
          } else {
            let updatedNodeComponent = {...nodeComponent};
            if (shouldUpdate(updatedNodeComponent)) {
              updatedNodeComponent.droppedId = payload.componentID;
              treeUpdate.updated = true;
              if (updatedNodeComponent.id !== payload.componentID) {
                incrementIncorrects();
              }
            }
            return updatedNodeComponent;
          }
        }

        function updateNodeComponentsList(nodeComponents) {
          if (nodeComponents.length <= 1) {
            return nodeComponents.map(updateNodeComponent);
          } else {
            /* when nodeComponents have more than one item
            we need to place a valid component at right spot and
            sort the list to display from left to right. */
            let validIds = fetchComponentIds(nodeComponents);
            if (validIds.includes(payload.componentID)) {
              let {component, otherComponents} = extractValidComponent(
                payload.componentID,
                nodeComponents
              );
              const droppedComponents = getDroppedNodeComponents(
                otherComponents
              );
              const undroppedComponents = getUndroppedNodeComponents(
                otherComponents
              );
              return [
                ...droppedComponents,
                updateNodeComponent(component),
                ...undroppedComponents,
              ];
            } else {
              return nodeComponents.map(updateNodeComponent);
            }
          }
        }

        function updateGroupNode(groupNode) {
          if (treeUpdate.updated) {
            return groupNode;
          } else {
            let updatedGroupNode = {...groupNode};
            /* To filter out JointPathSelect Component 
            that dosent have nodeComponents key */
            if (updatedGroupNode.hasOwnProperty(NODE_COMPONENTS)) {
              updatedGroupNode.nodeComponents = updateNodeComponentsList(
                updatedGroupNode.nodeComponents
              );
            }
            return updatedGroupNode;
          }
        }

        if (treeUpdate.updated) {
          treeUpdate.slideTree = [...treeUpdate.slideTree, {...group}];
        } else {
          let updatedGroup = {...group};
          updatedGroup.groupNodes = updatedGroup.groupNodes.map(
            updateGroupNode
          );
          treeUpdate.slideTree = [...treeUpdate.slideTree, {...updatedGroup}];
        }
        return treeUpdate;
      },
      {updated: false, slideTree: []}
    );
    if (getIncorrects() === 0) {
      slideTree = setNewCurrentNode(slideTree);
    }
    return {
      ...slideTwo,
      incorrects: slideTwo.incorrects + getIncorrects(),
      slideTree,
    };
  }

  return {
    ...state,
    protocolSection: updateDesignSection(state.protocolSection, payload),
  };
}

function getDroppedNodeComponents(nodeComponents) {
  return nodeComponents.filter(
    (nodeComponent) => nodeComponent.droppedId !== null
  );
}

function getUndroppedNodeComponents(nodeComponents) {
  return nodeComponents.filter(
    (nodeComponent) => nodeComponent.droppedId === null
  );
}

function extractValidComponent(nodeId, nodeComponents) {
  return nodeComponents.reduce(
    (result, nodeComponent) => {
      if (nodeComponent.id === nodeId) {
        result.component = {...nodeComponent};
      } else {
        result.otherComponents.push({...nodeComponent});
      }
      return result;
    },
    {
      component: null,
      otherComponents: [],
    }
  );
}
